export enum ExceptionType {
    ACCOUNT_EXCEPTION = 'ACCOUNT_EXCEPTION',
    ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
    EXPIRED_CERTIFICATE = 'EXPIRED_CERTIFICATE',
    OTHER = 'OTHER',
    RUNTIME_EXCEPTION = 'RUNTIME_EXCEPTION',
    UNPARSABLE_JSON = 'UNPARSABLE_JSON',
    UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS'
}
